<iframe referrerpolicy="strict-origin-when-cross-origin" class="tw-w-full tw-h-full" #vimeo_player id="vimeo-player"
  [attr.src]="url" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>